import { ref } from 'vue'
import type { BaseSearchFilters } from '../model'

export const useFiltersCount = () => {
  const selectedFiltersCount = ref(0)

  const setFiltersCount = (filters: BaseSearchFilters) => {
    selectedFiltersCount.value = Object.keys(filters.filter).filter(
      (item) => item !== 'tillDateTime'
    ).length
  }

  return {
    selectedFiltersCount,
    setFiltersCount
  }
}
